import Vue from 'vue'
import Vuex from 'vuex'
import test from './test'
import fileModule from './modules/fileModule'
import WebinarQuestion from './modules/WebinarQuestion'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    test, fileModule, WebinarQuestion
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js